<template>
  <div v-if="user.bohOrHigher">
    <HeaderBar>
      <v-icon slot="icon">table_chart</v-icon>
      Reports
    </HeaderBar>

    <v-layout row wrap justify-space-between class="mt-4">
      <v-flex xs4 pa-2>
        <GeoSegmentTile title="Geo Segments" />
      </v-flex>
      <v-flex xs4 pa-2>
        <EmployeeShiftCountTile title="Employee Shift Count" />
      </v-flex>
      <v-flex xs4 pa-2>
        <v-card elevation="2" height="100%">
          <v-card-text>
            <h2 class="display-1 mb-4">Birthdays & Anniversaries</h2>
          </v-card-text>
          <v-card-actions>
            <v-layout justify-end>
              <v-btn @click="getBirthdaysAnniversaries" color="primary">Birthdays & Anniversaries</v-btn>
            </v-layout>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>

    <v-layout row wrap justify-space-between class="mt-4">
      <v-flex xs4 pa-2>
        <v-card elevation="2" height="100%">
          <v-card-text>
            <h2 class="display-1 mb-4">Timecards</h2>
            <template>
              <v-flex>
                <v-menu
                  ref="startDateMenu"
                  v-model="startDateMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <template slot="activator" slot-scope="{ on }">
                    <v-text-field
                      label="Start Date"
                      format="dddd, MM DD YYYY"
                      @change="(value) => (startDate = value)"
                      :value="dateFormatted(startDate)"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="startDate" @input="startDateMenu = false" no-title scrollable :show-current="endDate">
                  </v-date-picker>
                </v-menu>
              </v-flex>
            </template>
            <template>
              <v-flex>
                <v-menu
                  ref="endDateMenu"
                  v-model="endDateMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <template slot="activator" slot-scope="{ on }">
                    <v-text-field
                      label="End Date"
                      format="dddd, MM DD YYYY"
                      @change="(value) => (endDate = value)"
                      :value="dateFormatted(endDate)"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="endDate" @input="endDateMenu = false" no-title scrollable :show-current="startDate">
                  </v-date-picker>
                </v-menu>
              </v-flex>
            </template>
            <v-card-actions>
              <v-layout justify-end>
                <v-btn @click="getRecords" color="primary"> Get Records </v-btn>
              </v-layout>
            </v-card-actions>
          </v-card-text>
        </v-card>
      </v-flex>

      <v-flex xs4 pa-2>
        <v-card elevation="2" height="100%">
          <v-card-text>
            <h2 class="display-1 mb-4">Payroll</h2>
            <template>
              <v-flex>
                <v-menu
                  ref="payrollStartDateMenu"
                  v-model="payrollStartDateMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <template slot="activator" slot-scope="{ on }">
                    <v-text-field
                      label="Start Date"
                      format="dddd, MM DD YYYY"
                      @change="(value) => (payrollStartDate = value)"
                      :value="dateFormatted(payrollStartDate)"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="payrollStartDate"
                    @input="payrollStartDateMenu = false"
                    no-title
                    scrollable
                    :show-current="payrollEndDate"
                  >
                  </v-date-picker>
                </v-menu>
              </v-flex>
            </template>
            <template>
              <v-flex>
                <v-menu
                  ref="payrollEndDateMenu"
                  v-model="payrollEndDateMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <template slot="activator" slot-scope="{ on }">
                    <v-text-field
                      label="End Date"
                      format="dddd, MM DD YYYY"
                      @change="(value) => (payrollEndDate = value)"
                      :value="dateFormatted(payrollEndDate)"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="payrollEndDate"
                    @input="payrollEndDateMenu = false"
                    no-title
                    scrollable
                    :show-current="payrollStartDate"
                  >
                  </v-date-picker>
                </v-menu>
              </v-flex>
            </template>
            <v-card-actions>
              <v-layout justify-end>
                <v-btn @click="getPayrollRecords" color="primary"> Get Payroll Report </v-btn>
              </v-layout>
            </v-card-actions>
          </v-card-text>
        </v-card>
      </v-flex>

      <v-flex xs4 pa-2>
        <v-card elevation="2" height="100%">
          <v-card-text>
            <h2 class="display-1 mb-4">Billing</h2>
            <template>
              <v-flex>
                <v-menu
                  ref="billingStartDateMenu"
                  v-model="billingStartDateMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <template slot="activator" slot-scope="{ on }">
                    <v-text-field
                      label="Start Date"
                      format="dddd, MM DD YYYY"
                      @change="(value) => (billingStartDate = value)"
                      :value="dateFormatted(billingStartDate)"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="billingStartDate"
                    @input="billingStartDateMenu = false"
                    no-title
                    scrollable
                    :show-current="billingEndDate"
                  >
                  </v-date-picker>
                </v-menu>
              </v-flex>
            </template>
            <template>
              <v-flex>
                <v-menu
                  ref="billingEndDateMenu"
                  v-model="billingEndDateMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <template slot="activator" slot-scope="{ on }">
                    <v-text-field
                      label="End Date"
                      format="dddd, MM DD YYYY"
                      @change="(value) => (billingEndDate = value)"
                      :value="dateFormatted(billingEndDate)"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="billingEndDate"
                    @input="billingEndDateMenu = false"
                    no-title
                    scrollable
                    :show-current="billingStartDate"
                  >
                  </v-date-picker>
                </v-menu>
              </v-flex>
            </template>
            <v-card-actions>
              <v-layout justify-end>
                <v-btn @click="getBillingRecords" color="primary"> Get Billing Report </v-btn>
              </v-layout>
            </v-card-actions>
          </v-card-text>
        </v-card>
      </v-flex>

      <v-layout>
        <v-flex xs4 pa-2>
          <v-card elevation="2" height="100%">
            <v-card-text>
              <h2 class="display-1 mb-4">Currently Working</h2>
              <p class="body">Show all employees currently clocked in to a shift</p>
            </v-card-text>
            <v-card-actions>
              <v-layout justify-end>
                <v-btn @click="getCurrentlyWorking" color="primary"> View Report </v-btn>
              </v-layout>
            </v-card-actions>
          </v-card>
        </v-flex>

        <v-flex xs4 pa-2>
          <v-card elevation="2" height="100%">
            <v-card-text>
              <h2 class="display-1 mb-4">Cancelled Shifts</h2>
            </v-card-text>
            <v-card-actions>
              <v-layout justify-end>
                <v-btn @click="getCancelledShifts" color="primary"> View Cancelled Shifts </v-btn>
              </v-layout>
            </v-card-actions>
          </v-card>
        </v-flex>

        <v-flex xs4 pa-2>
          <ClientFulfillmentTile title="Client Fulfillment Report" />
        </v-flex>
      </v-layout>
    </v-layout>

    <v-layout>
      <v-flex xs4 pa-2>
        <ClientTimeOrderedTile />
      </v-flex>
      <v-flex xs4 pa-2>
        <AllTimeOrderedTile />
      </v-flex>
      <v-flex xs4 pa-2>
        <EmployeeHoursAtClientTile title="Employee Hours at Location" />
      </v-flex>
    </v-layout>

    <v-layout>
      <v-flex xs4 pa-2>
        <EmployeeTimeWorkedTile title="Employee Time Worked" />
      </v-flex>
      <v-flex xs4 pa-2>
        <ReferralTile title="Referrals" />
      </v-flex>
      <v-flex xs4 pa-2>
        <CommLogTile title="Comm Log" />
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex xs4 pa-2>
        <IPAddressLogTile title="IP Address Report" />
      </v-flex>
      <v-flex xs4 pa-2>
        <v-card elevation="2" height="100%">
          <v-card-text>
            <h2 class="display-1 mb-4">Contact Report</h2>
          </v-card-text>
          <v-card-actions>
            <v-layout justify-end>
              <v-btn @click="getContactReport" color="primary">Get Contact Report</v-btn>
            </v-layout>
          </v-card-actions>
        </v-card>
      </v-flex>
      <v-flex xs4 pa-2></v-flex>
    </v-layout>
  </div>

  <div v-else-if="user.role == 'client'">
    <v-layout row wrap justify-start class="mt-4">
      <v-flex xs4 pa-2>
        <ClientFulfillmentTile title="Fulfillment Report (my shifts)" />
      </v-flex>
      <v-flex xs4 pa-2>
        <ClientLocationFulfillmentTile title="Fulfillment Report (my locations)" />
      </v-flex>

      <v-flex v-if="user.clientAdmin" xs4 pa-2>
        <v-card elevation="2" height="100%">
          <v-card-text>
            <h2 class="display-1 mb-4">Timecards</h2>
            <template>
              <v-flex>
                <v-menu
                  ref="startDateMenu"
                  v-model="startDateMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <template slot="activator" slot-scope="{ on }">
                    <v-text-field
                      label="Start Date"
                      format="dddd, MM DD YYYY"
                      @change="(value) => (startDate = value)"
                      :value="dateFormatted(startDate)"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="startDate" @input="startDateMenu = false" no-title scrollable :show-current="endDate">
                  </v-date-picker>
                </v-menu>
              </v-flex>
            </template>
            <template>
              <v-flex>
                <v-menu
                  ref="endDateMenu"
                  v-model="endDateMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <template slot="activator" slot-scope="{ on }">
                    <v-text-field
                      label="End Date"
                      format="dddd, MM DD YYYY"
                      @change="(value) => (endDate = value)"
                      :value="dateFormatted(endDate)"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="endDate" @input="endDateMenu = false" no-title scrollable :show-current="startDate">
                  </v-date-picker>
                </v-menu>
              </v-flex>
            </template>
            <v-card-actions>
              <v-layout justify-end>
                <v-btn @click="getRecords" color="primary"> Get Records </v-btn>
              </v-layout>
            </v-card-actions>
          </v-card-text>
        </v-card>
      </v-flex>

      <v-flex v-if="user.clientAdmin" xs4 pa-2>
        <v-card elevation="2" height="100%">
          <v-card-text>
            <h2 class="display-1 mb-4">Billing</h2>
            <template>
              <v-flex>
                <v-menu
                  ref="billingStartDateMenu"
                  v-model="billingStartDateMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <template slot="activator" slot-scope="{ on }">
                    <v-text-field
                      label="Start Date"
                      format="dddd, MM DD YYYY"
                      @change="(value) => (billingStartDate = value)"
                      :value="dateFormatted(billingStartDate)"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="billingStartDate"
                    @input="billingStartDateMenu = false"
                    no-title
                    scrollable
                    :show-current="billingEndDate"
                  >
                  </v-date-picker>
                </v-menu>
              </v-flex>
            </template>
            <template>
              <v-flex>
                <v-menu
                  ref="billingEndDateMenu"
                  v-model="billingEndDateMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <template slot="activator" slot-scope="{ on }">
                    <v-text-field
                      label="End Date"
                      format="dddd, MM DD YYYY"
                      @change="(value) => (billingEndDate = value)"
                      :value="dateFormatted(billingEndDate)"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="billingEndDate"
                    @input="billingEndDateMenu = false"
                    no-title
                    scrollable
                    :show-current="billingStartDate"
                  >
                  </v-date-picker>
                </v-menu>
              </v-flex>
            </template>
            <v-card-actions>
              <v-layout justify-end>
                <v-btn @click="getBillingRecords" color="primary"> Get Billing Report </v-btn>
              </v-layout>
            </v-card-actions>
          </v-card-text>
        </v-card>
      </v-flex>

      <v-flex v-if="user.clientAdmin" xs4 pa-2>
        <v-card elevation="2" height="100%">
          <v-card-text>
            <h2 class="display-1 mb-4">Currently Working</h2>
            <p class="body">Show all employees currently clocked in to a shift</p>
          </v-card-text>
          <v-card-actions>
            <v-layout justify-end>
              <v-btn @click="getCurrentlyWorking" color="primary"> View Report </v-btn>
            </v-layout>
          </v-card-actions>
        </v-card>
      </v-flex>

      <v-flex v-if="user.clientAdmin" xs4 pa-2>
        <v-card elevation="2" height="100%">
          <v-card-text>
            <h2 class="display-1 mb-4">Cancelled Shifts</h2>
          </v-card-text>
          <v-card-actions>
            <v-layout justify-end>
              <v-btn @click="getCancelledShifts" color="primary"> View Cancelled Shifts </v-btn>
            </v-layout>
          </v-card-actions>
        </v-card>
      </v-flex>

      <v-flex v-if="user.clientAdmin" xs4 pa-2>
        <ClientTimeOrderedTile />
      </v-flex>
    </v-layout>
  </div>

  <div v-else-if="user.role == 'manager'">
    <v-layout row wrap justify-start class="mt-4">
      <v-flex xs4 pa-2>
        <ClientFulfillmentTile title="Fulfillment Report" />
      </v-flex>
      <v-flex xs4 pa-2>
        <EmployeeShiftCountTile title="Employee Shift Count" />
      </v-flex>
      <v-flex xs4 pa-2>
        <EmployeeHoursAtClientTile title="Employee Hours at Location" />
      </v-flex>
      <v-flex xs4 pa-2>
        <EmployeeTimeWorkedTile title="Employee Time Worked" />
      </v-flex>
      <v-flex xs4 pa-2>
        <AllTimeOrderedTile />
      </v-flex>
      <v-flex xs4 pa-2>
        <v-card elevation="2" height="100%">
          <v-card-text>
            <h2 class="display-1 mb-4">Certification Expirations</h2>
          </v-card-text>
          <v-card-actions>
            <v-layout justify-end>
              <v-btn :to="{ name: 'certificationsReport' }" color="primary"> View Expiring Certifications </v-btn>
            </v-layout>
          </v-card-actions>
        </v-card>
      </v-flex>
      <v-flex xs4 pa-2>
        <TaskReportTile title="Tasks" />
      </v-flex>
      <v-flex xs4 pa-2>
        <ReferralTile title="Referrals" />
      </v-flex>

      <v-flex xs4 pa-2>
        <v-card elevation="2" height="100%">
          <v-card-text>
            <h2 class="display-1 mb-4">Birthdays & Anniversaries</h2>
          </v-card-text>
          <v-card-actions>
            <v-layout justify-end>
              <v-btn @click="getBirthdaysAnniversaries" color="primary">Birthdays & Anniversaries</v-btn>
            </v-layout>
          </v-card-actions>
        </v-card>
      </v-flex>

      <v-flex xs4 pa-2>
        <v-card elevation="2" height="100%">
          <v-card-text>
            <h2 class="display-1 mb-4">Cancelled Shifts</h2>
          </v-card-text>
          <v-card-actions>
            <v-layout justify-end>
              <v-btn @click="getCancelledShifts" color="primary"> View Cancelled Shifts </v-btn>
            </v-layout>
          </v-card-actions>
        </v-card>
      </v-flex>

      <v-flex xs4 pa-2>
        <v-card elevation="2" height="100%">
          <v-card-text>
            <h2 class="display-1 mb-4">Contact Report</h2>
          </v-card-text>
          <v-card-actions>
            <v-layout justify-end>
              <v-btn @click="getContactReport" color="primary">Get Contact Report</v-btn>
            </v-layout>
          </v-card-actions>
        </v-card>
      </v-flex>

      <v-flex xs4 pa-2>
        <v-card elevation="2" height="100%">
          <v-card-text>
            <h2 class="display-1 mb-4">Timecards</h2>
            <template>
              <v-flex>
                <v-menu
                  ref="startDateMenu"
                  v-model="startDateMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <template slot="activator" slot-scope="{ on }">
                    <v-text-field
                      label="Start Date"
                      format="dddd, MM DD YYYY"
                      @change="(value) => (startDate = value)"
                      :value="dateFormatted(startDate)"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="startDate" @input="startDateMenu = false" no-title scrollable :show-current="endDate">
                  </v-date-picker>
                </v-menu>
              </v-flex>
            </template>
            <template>
              <v-flex>
                <v-menu
                  ref="endDateMenu"
                  v-model="endDateMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <template slot="activator" slot-scope="{ on }">
                    <v-text-field
                      label="End Date"
                      format="dddd, MM DD YYYY"
                      @change="(value) => (endDate = value)"
                      :value="dateFormatted(endDate)"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="endDate" @input="endDateMenu = false" no-title scrollable :show-current="startDate">
                  </v-date-picker>
                </v-menu>
              </v-flex>
            </template>
            <v-card-actions>
              <v-layout justify-end>
                <v-btn @click="getRecords" color="primary"> Get Records </v-btn>
              </v-layout>
            </v-card-actions>
          </v-card-text>
        </v-card>
      </v-flex>

      <v-flex xs4 pa-2>
        <v-card elevation="2" height="100%">
          <v-card-text>
            <h2 class="display-1 mb-4">Currently Working</h2>
            <p class="body">Show all employees currently clocked in to a shift</p>
          </v-card-text>
          <v-card-actions>
            <v-layout justify-end>
              <v-btn @click="getCurrentlyWorking" color="primary"> View Report </v-btn>
            </v-layout>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </div>

  <div v-else>There are no reports yet</div>
</template>

<script>
import { mapState } from "vuex";
import HeaderBar from "@/components/base/header-bar.vue";
import ClientTimeOrderedTile from "@/components/reports/client-time-ordered-tile.vue";
import ClientFulfillmentTile from "@/components/reports/client-fulfillment-tile.vue";
import ClientLocationFulfillmentTile from "@/components/reports/client-location-fulfillment-tile.vue";
import EmployeeShiftCountTile from "@/components/reports/shift-count-tile.vue";
import AllTimeOrderedTile from "@/components/reports/all-time-ordered-tile.vue";
import EmployeeHoursAtClientTile from "@/components/reports/employee-hours-at-client-tile.vue";
import TaskReportTile from "@/components/reports/task-report-tile.vue";
import ReferralTile from "@/components/reports/referral-report-tile.vue";
import CommLogTile from "@/components/reports/comm-log-report-tile.vue";
import EmployeeTimeWorkedTile from "@/components/reports/employee-time-worked-tile.vue";
import GeoSegmentTile from "@/components/reports/geo-segment-tile.vue";
import IPAddressLogTile from "@/components/reports/ipaddress-log-report-tile.vue";

export default {
  components: {
    HeaderBar,
    ClientTimeOrderedTile,
    ClientFulfillmentTile,
    ClientLocationFulfillmentTile,
    EmployeeShiftCountTile,
    AllTimeOrderedTile,
    EmployeeHoursAtClientTile,
    TaskReportTile,
    ReferralTile,
    CommLogTile,
    EmployeeTimeWorkedTile,
    GeoSegmentTile,
    IPAddressLogTile,
  },
  computed: {
    ...mapState("userAuth", ["user"]),
  },
  created() {},
  watch: {},
  data: function () {
    return {
      startDateMenu: false,
      endDateMenu: false,
      startDate: this.$moment().subtract(3, "weeks").format("YYYY-MM-DD"),
      endDate: this.$moment().subtract(1, "weeks").format("YYYY-MM-DD"),
      payrollStartDateMenu: false,
      payrollEndDateMenu: false,
      payrollStartDate: this.$moment().subtract(3, "weeks").format("YYYY-MM-DD"),
      payrollEndDate: this.$moment().subtract(1, "weeks").format("YYYY-MM-DD"),
      billingStartDateMenu: false,
      billingEndDateMenu: false,
      billingStartDate: this.$moment().subtract(3, "weeks").format("YYYY-MM-DD"),
      billingEndDate: this.$moment().subtract(1, "weeks").format("YYYY-MM-DD"),
      mfrStartDateMenu: false,
      mfrEndDateMenu: false,
      mfrStartDate: this.$moment().subtract(8, "weeks").format("YYYY-MM-DD"),
      mfrEndDate: this.$moment().subtract(1, "weeks").format("YYYY-MM-DD"),
    };
  },
  methods: {
    getRecords: function () {
      this.$router.push({
        name: "timeclockReports",
        query: {
          startDate: this.startDate,
          endDate: this.endDate,
          page: 1,
          limit: 50,
        },
      });
    },
    getPayrollRecords: function () {
      this.$router.push({
        name: "payrollReports",
        query: {
          startDate: this.payrollStartDate,
          endDate: this.payrollEndDate,
        },
      });
    },
    getBillingRecords: function () {
      this.$router.push({
        name: "billingReports",
        query: {
          startDate: this.billingStartDate,
          endDate: this.billingEndDate,
        },
      });
    },
    getManagerFulfilledShifts: function () {
      this.$router.push({
        name: "managerFulfillmentReport",
        query: {
          startDate: this.mfrStartDate,
          endDate: this.mfrEndDate,
        },
      });
    },
    getCurrentlyWorking: function () {
      this.$router.push({
        name: "currentlyWorkingReport",
      });
    },
    getCancelledShifts: function () {
      this.$router.push({
        name: "cancelledShifts",
      });
    },
    getBirthdaysAnniversaries: function () {
      this.$router.push({
        name: "birthdaysAnniversaries",
      });
    },
    getContactReport: function () {
      this.$router.push({
        name: "contactReport",
      });
    },
    dateFormatted: function (date) {
      return date ? this.$moment(date).format("dddd, MMMM D") : "";
    },
  },
};
</script>

<style scoped></style>
